<template>
  <div class="">
    <div class="profile-top">
      <div class="title">
        <h2>My Offers</h2>
      </div>
      <button class="button" @click="openSaleSkinModal">
        <span>Sell skins</span>
      </button>
    </div>

    <div class="profile-table" v-if="offerHistory">
      <div class="profile-table-wrapper profile-form-wrapper">
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <td>ID</td>
                <td>Date</td>
                <td>Skin name</td>
                <td>Status</td>
                <td>Total</td>
                <td>Details</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in offerHistory" :key="i">
                <td>{{ item.id }}</td>
                <td>{{ formatDate(item.date_time) }}</td>
                <td>
                  {{ item.title }}
                </td>
                <td v-if="item.status == 'offer'" class="green">
                  <span class="status">{{ item.status_display }}</span>
                </td>
                <td v-else-if="item.status == 'declined'" class="red">
                  <span class="status">{{ item.status_display }}</span>
                </td>
                <td v-else>
                  <span class="status">{{ item.status_display }}</span>
                </td>
                <td class="desc">
                  <b>
                    {{ item.service_price ? item.service_price : item.user_price }}
                    {{ item.currency }}
                  </b>
                </td>

                <td>
                  <a class="offer-modal-open desc link" @click="openOfferDetailsModal(item)"> <b>View</b></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination" id="pagination"></div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapState, mapActions } from 'vuex'
  import moment from 'moment-timezone'

  export default {
    name: 'MyOffersTab',
    props: [],
    components: {},
    data: function () {
      return {}
    },
    computed: {
      ...mapGetters('app', ['currencySymbol', 'currency']),
      ...mapState('offers', ['offerHistory', 'isLoading', 'error'])
    },
    methods: {
      ...mapActions('offers', ['fetchOfferHistory']),
      ...mapActions('modals', ['openSaleSkinModal', 'openOfferDetailsModal']),

      formatDate(timestamp) {
        return this.$store.getters['offers/formatDate'](timestamp)
      },

      formatToEST(timestamp) {
        if (!timestamp) return ''
        const momentObj = typeof timestamp === 'number' ? moment.unix(timestamp) : moment(timestamp, 'DD.MM.YYYY HH:mm')

        return momentObj.tz('Europe/Tallinn').format('DD.MM.YYYY HH:mm')
      }
    },
    mounted() {
      this.fetchOfferHistory()
    }
  }
</script>

<style scoped>
  .profile-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 26px;
    padding: 42px 42px 42px 32px;
    background-color: #fbfbfb;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .profile-top .title {
    font-size: 24px;
  }

  .profile-top button {
    height: auto;
  }
</style>
